
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.885 9.765A3.766 3.766 0 0113.65 6h20.585A3.766 3.766 0 0138 9.765v24.47A3.766 3.766 0 0134.235 38H9.765A3.765 3.765 0 016 34.235V19.18a3.769 3.769 0 013.768-3.768h.117V9.765zm-.015 7.568A1.87 1.87 0 008 19.203v14.93C8 35.164 8.835 36 9.867 36h24.266c1.03 0 1.867-.837 1.867-1.867V9.867C36 8.837 35.163 8 34.133 8H13.72c-1.03 0-1.866.837-1.866 1.867v21.957a.933.933 0 01-1.867 0v-14.49H9.87zM15.111 32C14.497 32 14 31.552 14 31s.497-1 1.111-1H32.89c.614 0 1.111.448 1.111 1s-.497 1-1.111 1H15.11zm0-5C14.497 27 14 26.552 14 26s.497-1 1.111-1H32.89c.614 0 1.111.448 1.111 1s-.497 1-1.111 1H15.11zm-.667-6C14.2 21 14 20.552 14 20s.199-1 .444-1h7.112c.245 0 .444.448.444 1s-.199 1-.444 1h-7.112zm0-6C14.2 15 14 14.552 14 14s.199-1 .444-1h7.112c.245 0 .444.448.444 1s-.199 1-.444 1h-7.112zM25 22a1 1 0 01-1-1v-8a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1h-8zm1-2h6v-6h-6v6z"}})])
          )
        }
      }
    